// extracted by mini-css-extract-plugin
export default {"logoContainer":"HeaderLogo-module__logoContainer___EmoFa","logoImage":"HeaderLogo-module__logoImage___iENm7","logoText":"HeaderLogo-module__logoText___ttzAP"};